import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { LogService, Project, ProjectCMS, ProjectCMSPage } from 'htv-lib'
import { LanguageService } from './language.service'

@Injectable({
  providedIn: 'root',
})
export class ProjectService {
  project?: Project
  projectCMS?: ProjectCMS

  projectCMSPages: ProjectCMSPage[] = []
  projectStartPageId?: string

  isLoading$ = new BehaviorSubject<boolean>(true)

  constructor(
    private logService: LogService,
    private languageService: LanguageService
  ) {
    // do nothing
  }

  init(project: Project): void {
    this.isLoading$.next(true)
    this.logService.debug('[ProjectService] Initializing with Humecloud data')

    this.project = project
    this.projectCMS = project.cms
    this.projectStartPageId = project.cms.startPageId
    this.logService.debug('[ProjectService] Start Page: ' + this.projectStartPageId)

    this.projectCMSPages = project.cms.pages
    this.logService.debug('[ProjectService] Number of CMS Pages: ' + this.projectCMSPages.length)

    this.isLoading$.next(false)
  }

  getProjectPageStartId(): string {
    return this.projectStartPageId ?? ''
  }

  getPageById(pageId: string): ProjectCMSPage | undefined {
    return this.projectCMSPages.find(p => p.id === pageId)
  }

  getProjectTranslations(): Record<string, string> {
    const selectedLanguage = this.languageService.getSelectedLanguage()
    const translations: Record<string, string> = {}

    this.project?.multilingual.forEach(entry => {
      if (!entry.translationId) return

      const selectedTranslation = entry.translations?.[selectedLanguage.code]
      const internationalTranslation = entry.translations?.['international']

      if (selectedTranslation) {
        translations[entry.translationId] = selectedTranslation
      } else if (internationalTranslation) {
        translations[entry.translationId] = internationalTranslation
      }
    })

    return translations
  }

  getProjectGeneralConfig() {
    return this.project?.configuration?.generalConfig
  }

  getProjectGlobalCustomization() {
    return this.project?.configuration.customizationGlobalConfig
  }

  getProjectActiveButtonCustomization() {
    return this.project?.configuration.customizationActiveMenuConfig
  }

  getProjectInactiveButtonCustomization() {
    return this.project?.configuration.customizationInactiveMenuConfig
  }
}
